<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>设备管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>版本列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>版本列表</span>
        </div>
        <span class="xcx-add left font14" @click="dialogFormVisible = true">添加版本</span>
      </div>
      <div class="search-box mt10">
        <el-form :inline="true">
          <el-form-item>
            <el-input placeholder="请输入关键词" v-model="search.keys"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getIndex()" icon="el-icon-search" type="primary">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="getClearIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table
          size="mini"
          border
          :data="tableData"
          stripe
          style="width: 100%"
          v-loading="loading"
          row-key="id"
          default-expand-all
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <el-table-column label="设备类型" width="100">
            <template slot-scope="scope" v-if="scope.row.children">{{ scope.row.title }}</template>
          </el-table-column>
          <el-table-column prop="type_title" label="软件类型" width="100"></el-table-column>
          <el-table-column prop="version" label="版本号" width="120"></el-table-column>
          <el-table-column prop="nick" label="版本文件" width="200"></el-table-column>
          <el-table-column prop="check" label="校验码" width="120"></el-table-column>
          <el-table-column prop="desc" label="版本更新说明"></el-table-column>
          <el-table-column width="160" label=" 发布时间">
            <template slot-scope="scope">
              <div v-if="!scope.row.children">{{ scope.row.created_at }}</div>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <div v-if="!scope.row.children">
                <el-dropdown @command="handleCommand">
                  <span class="el-dropdown-link">
                    操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="{ 'command': 'edit', 'ids': scope.row.id }">修改</el-dropdown-item>
                    <el-dropdown-item :command="{ 'command': 'del', 'ids': scope.row.id }">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog
      title="添加版本"
      width="40%"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
    >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="设备类型：" :label-width="formLabelWidth" prop="title">
          <el-select v-model="ruleForm.title" placeholder="请选择设备类型">
            <el-option label="请选择" :value="0"></el-option>
            <el-option
              v-for="item in cateList"
              :key="item.id"
              :label="item.title"
              :value="item.title"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="软件类型：" :label-width="formLabelWidth" prop="type">
          <el-select v-model="ruleForm.type" placeholder="请选择软件类型">
            <el-option label="请选择" :value="0"></el-option>
            <el-option label="触控" :value="1"></el-option>
            <el-option label="中控" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="版本号：" :label-width="formLabelWidth" prop="version">
          <el-input v-model="ruleForm.version" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="版本文件：" :label-width="formLabelWidth" prop="nick">
          <el-input v-model="ruleForm.nick" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="校验码：" :label-width="formLabelWidth" prop="check">
          <el-input v-model="ruleForm.check" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="上传文件：" :label-width="formLabelWidth" prop="urls">
          <el-upload
            class="upload-demo"
            name="image"
            action="https://api.iztrv.com/uploadtxt"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            :before-remove="beforeRemove"
            multiple
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传.bin文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="更新说明 ：" :label-width="formLabelWidth" prop="desc">
          <el-input type="textarea" rows="5" v-model="ruleForm.desc" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog()">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      tableData: [],
      search: {
        keys: "",
      },
      fileList: [],
      cateList: [],
      dialogFormVisible: false,
      formLabelWidth: "120px",
      ruleForm: {
        title: "",
        type: "",
        version: "",
        nick: "",
        urls: "",
        check: "",
        desc: "",
        devid: "",
      },
      rules: {
        title: [{ required: true, message: "请选择设备类型", trigger: "blur" }],
        type: [{ required: true, message: "请选择软件类型", trigger: "blur" }],
        version: [{ required: true, message: "请输入版本号", trigger: "blur" }],
        urls: [{ required: true, message: "请上传版本", trigger: "blur" }],
        check: [{ required: true, message: "请添加校验码", trigger: "blur" }],
      },
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
    that.getCate();
  },
  methods: {
    handleCommand(command) {
      console.log(command);
      if (command.command == "edit") {
        var that = this;
        that.id = command.ids;
        that.axios.post("/version/edit", { id: command.ids }).then((res) => {
          if (res) {
            that.ruleForm = res.data;
            that.dialogFormVisible = true;
          }
        });
      } else if (command.command == "del") {
        this.del_item(command.ids);
      }
    },
    handleAvatarSuccess(res, file) {
      console.log(res);
      if (res.status == 200) {
        this.ruleForm.urls = res.msg;
        this.ruleForm.nick = res.title;
      } else {
        this.$message.warning(res.msg);
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    getIndex() {
      this.getList();
    },
    getClearIndex() {
      this.search.keys = "";
      this.getList();
    },
    closeDialog() {
      //this.$refs['ruleForm'].resetFields();
      this.dialogFormVisible = false;
      this.ruleForm.title = "";
      this.ruleForm.length = "";
      this.ruleForm.price = "";
      this.ruleForm.o_price = "";
    },
    getCate(ids) {
      var that = this;
      that.id = ids;
      that.axios.post("/dev_type/getCate").then((res) => {
        if (res) {
          that.cateList = res.data;
        }
      });
    },
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    del_item(ids) {
      let that = this;
      this.$confirm("此操作不可逆, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.axios
          .post("/version/destroy", {
            ids: ids,
          })
          .then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              that.getList();
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          });
      });
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      formData.cat_id = 0;
      formData.keys = that.search.keys;
      that.axios.post("/version/index", formData).then((res) => {
        if (res) {
          that.tableData = res.data;
          that.loading = false;
        }
      });
    },
    /**
     * 提交信息
     */
    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.ruleForm;
        var url = "/version/store";
        if (that.id) {
          formData.id = that.id;
          url = "/version/update";
        }
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.dialogFormVisible = false;
          that.getList();
        });
      });
    },
  },
};
</script>
<style>
.search-box {
  padding: 0 20px;
}
</style>